import { render, staticRenderFns } from "./CourseExam.vue?vue&type=template&id=47e772e2&scoped=true&"
import script from "./CourseExam.vue?vue&type=script&lang=js&"
export * from "./CourseExam.vue?vue&type=script&lang=js&"
import style0 from "./CourseExam.vue?vue&type=style&index=0&id=47e772e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e772e2",
  null
  
)

export default component.exports